import { useState } from "react";
import { Sofa } from "lucide-react";
import { ROOM_SCENES } from "./roomScenes";
import { imgUrl } from "@/lib/api";
import { Watermark } from "./Watermark";

export const RoomPreview = ({ src, title, w, h, frameColor }) => {
  const [key, setKey] = useState("living");
  const scene = ROOM_SCENES.find(s => s.key === key);
  const { W, H, artBottom, artCenterX } = scene;
  const f = H - 18;
  const art = { left: (artCenterX - w / 2) / W * 100, top: (artBottom - h) / H * 100, width: w / W * 100, height: h / H * 100 };
  const frameFill = { black: "#111", white: "#fafafa", "dark-wood": "#4a3320", "natural-wood": "#c9a56a" }[frameColor];

  return (
    <div data-testid="room-preview">
      <div className="flex items-center justify-between mb-3">
        <div className="overline text-mute inline-flex items-center gap-2"><Sofa size={12}/> View on a Wall</div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-mute" data-testid="room-preview-scale">{w}×{h} in · {scene.scaleNote}</div>
      </div>
      <div className="flex flex-wrap gap-1.5 mb-3">
        {ROOM_SCENES.map(s => (
          <button key={s.key} onClick={() => setKey(s.key)} data-testid={`room-${s.key}`}
            className={`px-3 py-1.5 text-[10px] uppercase tracking-[0.18em] border transition-colors duration-200 ${key === s.key ? "border-ink bg-ink text-cream" : "border-line text-ink-soft hover:border-ink"}`}>
            {s.label}
          </button>
        ))}
      </div>
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: `${W} / ${H}` }} data-testid="room-scene">
        <svg viewBox={`0 0 ${W} ${H}`} className="absolute inset-0 w-full h-full" preserveAspectRatio="none">
          <rect width={W} height={H} fill={scene.wall} />
          <rect y={H - 1} width={W} height={1} fill="rgba(0,0,0,0.15)" />
          <rect y={f} width={W} height={18} fill={scene.floor} />
          <rect y={f - 3} width={W} height={3} fill="rgba(255,255,255,0.35)" />
          {scene.draw(f)}
        </svg>
        <div className="absolute" style={{ left: `${art.left}%`, top: `${art.top}%`, width: `${art.width}%`, height: `${art.height}%`,
          boxShadow: "0 6px 18px -6px rgba(0,0,0,0.45)", outline: frameFill ? `3px solid ${frameFill}` : "none" }} data-testid="room-artwork">
          <img src={imgUrl(src, 640)} alt={title} loading="lazy" decoding="async" className="w-full h-full object-cover" />
        </div>
        <Watermark />
      </div>
    </div>
  );
};
